export const REQUEST_RESET_CODE_VALIDATION = "REQUEST_RESET_CODE_VALIDATION";
export const GRANT_RESET_CODE_VALIDATION = "GRANT_RESET_CODE_VALIDATION";
export const REVOKE_RESET_CODE_VALIDATION = "REVOKE_RESET_CODE_VALIDATION";
export const RESET_RESET_CODE_VALIDATION = "RESET_RESET_CODE_VALIDATION";
